// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import '../static/js/util'
import api from './api'
import store from "./store"
import 'vant/lib/index.css';
import Vant from 'vant';

Vue.use(Vant);
Vue.use(MintUI)
Vue.use(api);
Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-app', 'wx-open-launch-weapp']; 
// if(location.host.indexOf(':')>0){
  // Cookies.set('uid','7')
  // Cookies.set('token','628aeaa1886c8de98168659afd911ef4')
  // Cookies.set('expire_timestamp','1690879394')
// }

// if(location.host.indexOf(':')>0){
//   Cookies.set('uid','1663774')
//   Cookies.set('token','5539e2ca65a15d61c3bed80e99c439d1')
//   Cookies.set('expire_timestamp','1690623935')
// }

if(location.host.indexOf(':')>0){
  Cookies.set('api_env','pro');
  Cookies.set('uid','17')
  Cookies.set('token','238658a7acbb4db4c61a8a5bfd45bdd6')
  Cookies.set('expire_timestamp','1700547596')
}

//  陈
// if(location.host.indexOf(':')>0){
//   Cookies.set('uid','8')
//   Cookies.set('token','87e2619b4959f050c2e4f774867b8afc')
//   Cookies.set('expire_timestamp','1690858968')
// }
// if(location.host.indexOf(':')>0){
//   Cookies.remove('uid')
//   Cookies.remove('token')
//   Cookies.remove('expire_timestamp')
// }



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js